const columns = (vm) => [
    { data: "tipo_comprobante", title: "Tipo" },
    { data: "consecutivo", title: "Consecutivo" },
    { data: "tercero_nit", title: "Identificación" },
    { data: "tercero_nombre", title: "Cliente" },
    { data: "sucursal", title: "Sucursal", class: "text-center" },
    { data: "centro_costo", title: "Centro Costo" },
    { data: "fecha", title: "Fecha" },
    { data: "moneda", title: "Moneda", class: "text-center" },
    { data: "tasa_cambio", title: "Tasa Cambio", class: "text-right" },
    { data: "nombre_contacto", title: "Contacto" },
    { data: "email_contacto", title: "Email" },
    { data: "orden_entrega", title: "Orden Entrega" },
    { data: "fecha_entrega", title: "Fecha Entrega" },
    { data: "producto_plu", title: "Código Producto" },
    { data: "producto_nombre", title: "Producto" },
    { data: "identificacion_vendedor", title: "Vendedor" },
    { data: "codigo_bodega", title: "Bodega" },
    { data: "cantidad", title: "Cantidad", class: "text-right" },
    { data: "precio", title: "Valor Unitario", class: "text-right" },
    { data: "descuento_producto", title: "Descuento", class: "text-right" },
    { data: "base_aiu", title: "Base AIU", class: "text-right" },
    { data: "identificacion_ingreso_tercero", title: "Ingreso Tercero" },
    { data: "codigo_impuesto_cargo", title: "Imp. Cargo" },
    { data: "codigo_impuesto_cargo_dos", title: "Imp. Cargo 2" },
    { data: "codigo_impuesto_retencion", title: "Retención" },
    { data: "codigo_reteica", title: "ReteICA" },
    { data: "codigo_reteiva", title: "ReteIVA" },
    { data: "codigo_forma_pago", title: "Forma Pago" },
    { data: "valor_forma_pago", title: "Valor Pago", class: "text-right" },
    { data: "fecha_vencimiento", title: "Vencimiento" },
    { data: "observaciones", title: "Observaciones" }
];

export default columns;